'use strict';

const Enum = require('./enum');

/**
 * Defines log actions.
 *
 * @enum
 * @readonly
 */
const LogActions = Object.create(Enum, {
  LOCK_DATA: { value: 'lockdata', enumerable: true },
  LOCK_COMMAND: { value: 'lockcommand', enumerable: true },
  LOCK_OPERATE_DATA: { value: 'lockoperatedata', enumerable: true },
});

const LogTypes = Object.create(Enum, {
  LOCK_OPERATION: { value: 'LockOperation', enumerable: true },
  KEYPAD_INFO: { value: 'KeypadInfo', enumerable: true },
  KEYPAD_OPEN: { value: 'KeypadOpen', enumerable: true },
  KEYPAD_WRONG_CODE: { value: 'KeypadWrongCode', enumerable: true },
  KEYPAD_CLOSE: { value: 'KeypadClose', enumerable: true },
  KEYPAD_ONE_TOUCH: { value: 'KeypadOneTouch', enumerable: true },
  BCM_TEST: { value: 'BCMTest', enumerable: true },
  DOOR_STATE_CHANGED: { value: 'DoorStateChanged', enumerable: true },
  CREDENTIAL_OPERATION: { value: 'CredentialOperation', enumerable: true },
  TAMPER_OPERATION: { value: 'Tamper', enumerable: true },
  ACCESSORY_EVENT: { value: 'AccessoryEvent', enumerable: true },
});

exports.LogActions = LogActions;
exports.LogTypes = LogTypes;
